import { useAuth } from '@/contexts/AuthContext';

/**
 * Returns { propertyId, unitId } for the authenticated employee.
 * The unitId is the employee's company/tenant identifier (enterprise unit).
 * Returns null if the user is not an employee.
 */
export function useEmployeeContext(): { propertyId: string; unitId: string } | null {
  const { user } = useAuth();
  if (!user) return null;
  const role = user.propertyRoles.find((r) => r.role === 'employee');
  if (!role?.propertyId || !role.unitId) return null;
  return { propertyId: role.propertyId, unitId: role.unitId };
}
